import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loginStart } from '../../actions/keycloak';

import KeycloakJS from 'keycloak-js';
import config from '../../config';
import { Spin } from 'antd';

class Login extends Component {
    state = {
    redirecting: false
  };

  componentDidMount() {
      this.initializeKeycloak();
  }

  handleLoginClick = () => {
    console.log("Login button clicked - manually starting login process");
    this.initializeKeycloak();
  }

 initializeKeycloak = () => {
    this.setState({ redirecting: true });
    this.props.loginStart();

    const keycloak = new KeycloakJS({
      realm: config.keycloak.realm,
      url: config.keycloak.url,
      clientId: config.keycloak.resource
    });
    keycloak.init({
        checkLoginIframe: false,
        enableLogging: true,
      })
      .then(authenticated => {

        if (!authenticated) {
            keycloak.login();
        } else {
          console.log("Already authenticated in Keycloak");
          const redirectUrl = sessionStorage.getItem('redirectAfterLogin') || '/';
          sessionStorage.removeItem('redirectAfterLogin');
          window.location.href = redirectUrl;
        }
      })
      .catch(error => {
        console.error("Keycloak initialization error:", error);
      });
  }


  render() {
    const { redirecting } = this.state;
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <h2>Bienvenido a SIJUP</h2>
        <p>Para continuar, por favor inicie sesión con su cuenta institucional</p>
        {redirecting ? (
          <div style={{ marginTop: '30px' }}>
            <Spin size="large" />
            <p style={{ marginTop: '15px', color: '#666' }}>
              Redirigiendo al servidor de autenticación...
            </p>
          </div>
        ): "" }
        <button 
          onClick={this.handleLoginClick}
          style={{
            marginTop: '20px',
            padding: '10px 20px',
            fontSize: '16px',
            background: '#1890ff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Iniciar Sesión
        </button>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isLoggingIn: state && state.keycloak ? state.keycloak.isLoggingIn : false,
    isLoggedIn: state && state.keycloak ? state.keycloak.isLoggedIn : false,
  };
}

export default connect(mapStateToProps, { loginStart })(Login);